export enum ToasterTypeEnum {
    SUCCESS = 0,
    ERROR = 1,
    INFO = 2,
    WARNING = 3,
};
